import {
  GraphQlClient,
  Lodash,
  Url,
  Http,
} from '@intelipost-js/secure-providers';
import {
  ScDialog,
  ScToast,
} from '@intelipost-js/secure-components';

export default {
  getUsers({ commit }) {
    commit('setLoading', true);

    return Http.get('api/v1/user/list')
      .then((res) => {
        commit('setLoading', false);
        commit('setUsers', res.data.content);
        return res;
      })
      .catch(() => {
        commit('setLoading', false);
      });
  },
  getUser({ commit, state, dispatch }, userId) {
    return dispatch('getUsers')
      .then(() => new Promise((resolve, reject) => {
        const userSelected = state.users.find(user => Number(user.id) === Number(userId));
        if (userSelected) {
          commit('setUser', userSelected);
          return resolve();
        }

        return reject();
      }));
  },
  createUser({ commit, state }) {
    commit('setLoading', true);
    return Http.post('api/v1/user/add', state.user)
      .then(() => {
        commit('setLoading', false);
        ScToast.success('Usuário criado com sucesso.');
      })
      .catch(() => {
        commit('setLoading', false);
      });
  },
  updateUser({ commit, state }, newUserData = {}) {
    commit('setLoading', true);
    const userData = {
      ...state.user,
      ...newUserData,
    };

    return Http.put('api/v1/user', userData)
      .then(() => {
        commit('setLoading', false);
        ScToast.success('Usuário atualizado com sucesso.');
      })
      .catch(() => {
        commit('setLoading', false);
      });
  },
  removeUser({ commit, dispatch }, user) {
    ScDialog.confirm({
      title: 'Tem certeza?',
      message: `Realmente gostaria de excluir o usuário <strong>${user.first_name}</strong> ?`,
      confirmText: 'Excluir usuário',
      type: 'is-danger',
      hasIcon: true,
      icon: 'times-circle',
      onConfirm: () => {
        commit('setLoading', true);
        return Http.delete(Url.toQueryString('api/v1/user', null, [user.id]))
          .then(() => dispatch('getUsers'))
          .then(() => {
            commit('setLoading', false);
            ScToast.success('Usuário excluído com sucesso.');
          })
          .catch(() => {
            commit('setLoading', false);
          });
      },
    });
  },
  unblockUser({ commit }, user) {
    commit('setLoading', true);
    return Http.put(Url.toQueryString('api/v1/user', null, [`${user.id}/unblock`]))
      .then(() => {
        ScToast.success('Usuário desbloqueado com sucesso');
        commit('setLoading', false);
      });
  },
  exportUser({ commit }) {
    commit('setLoadingExporting', true);
    return GraphQlClient.mutation(`
      mutation {
        userExport {
          download_url
        }
      }
    `).then(({ data = {} }) => {
      const { userExport = {} } = data;
      const { download_url = '' } = userExport;
      commit('setLoadingExporting', false);
      window.open(download_url, '_blank');
    }).catch((err) => {
      commit('setLoadingExporting', false);
      return Promise.reject(err);
    });
  },
  getUsersPagination({ commit }, { page, limit }) {
    commit('setLoading', true);
    return GraphQlClient.query(`
    query {
      getUsersPagination(page: ${page}, limit: ${limit}) {
          user_count
          users {
            id
            first_name
            last_name
            user_group_id
            email
            enabled
            blocked
            warehouse_ids
          }
          has_next_page
      }
    }
  `)
    .then((response) => {
      const data = response.data || {};
      const { getUsersPagination } = data;
      if (getUsersPagination) {
        commit('setUsersPagination', getUsersPagination);
        commit('setLoading', false);
        return getUsersPagination;
      }
      throw new Error('Failed to fetch paginated list of users.');
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },
  getUsersPaginationMigrated({ commit }, { page, limit }) {
    commit('setLoading', true);
    return GraphQlClient.query(`
    query {
      getUsersPaginationMigrated(page: ${page}, limit: ${limit}) {
          user_count
          users {
            id
            first_name
            last_name
            user_group_id
            email
            enabled
            blocked
            warehouse_ids
          }
          has_next_page
      }
    }
  `)
    .then((response) => {
      const data = response.data || {};
      const getUsersPagination = data.getUsersPaginationMigrated;
      if (getUsersPagination) {
        commit('setUsersPagination', getUsersPagination);
        commit('setLoading', false);
        return getUsersPagination;
      }
      throw new Error('Failed to fetch paginated list of users.');
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },
  removeUserPaginated({ commit, dispatch }, payload) {
    const { user, currentPage, currentLimit } = payload;
    ScDialog.confirm({
      title: 'Tem certeza?',
      message: `Realmente gostaria de excluir o usuário <strong>${user.first_name}</strong> ?`,
      confirmText: 'Excluir usuário',
      type: 'is-danger',
      hasIcon: true,
      icon: 'times-circle',
      onConfirm: () => {
        commit('setLoading', true);
        return Http.delete(Url.toQueryString('api/v1/user', null, [user.id]))
          .then(async () => {
            await dispatch('getUsersPagination', ({ page: currentPage, limit: currentLimit }));
            commit('setLoading', false);
            ScToast.success('Usuário excluído com sucesso.');
          })
          .catch(() => {
            commit('setLoading', false);
          });
      },
    });
  },
  getAccessUsers({ commit }) {
    commit('setLoading', true);
    return GraphQlClient.query(`
    query{
      getAccessUsers{
        id
        first_name
        last_name
        email
        enabled
        blocked
        is_admin
      }
    }`)
    .then(({ data }) => {
      const { getAccessUsers: users } = data;
      commit('setLoading', false);
      return Promise.resolve(users || []);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  getAccessUser({ commit }, userId) {
    commit('setLoading', true);
    return GraphQlClient.query(`
    query(
      $userId: Int
    ){
      getAccessUser(
        id: $userId
      ) {
        id
        first_name
        last_name
        email
        enabled
        warehouse_ids
        external_id
        isAdmin
        groups {
          id
          externalId
          name
          active
        }
        profiles {
          id
          name
          sigla
          active
        }
      }
    }
    `, { userId })
    .then(({ data }) => {
      const { getAccessUser: accessUser } = data;
      commit('setAccessUser', accessUser || {});
      commit('setLoading', false);
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  getAccessUserGroups({ commit, state }) {
    commit('setLoading', true);
    return GraphQlClient.query(`
    query{
      getAccessGroups{
        id
        name
        externalId
      }
    }`)
    .then(({ data }) => {
      const { getAccessGroups } = data;
      let groups;
      commit('setLoading', false);
      if (getAccessGroups && getAccessGroups.length) {
        groups = getAccessGroups.reduce((acc, current) => [
          ...acc,
          { ...current, active: false },
        ], []);
        const userEdit = Lodash.cloneDeep(state.accessUser);
        commit('setAccessUser', Object.assign(userEdit, { groups }));
        return Promise.resolve(data);
      }
      ScToast.danger('É necessário existir Grupo(s) cadastrados');
      return Promise.reject();
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  createAccessUser({ commit, state }) {
    commit('setLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $first_name: String!
      $last_name: String!
      $email: String!
      $enabled: Boolean!
      $warehouse_ids: [Int]!
      $groupIds: [Int]!
      $profileIds: [Int]
      $external_id: String
    ) {
      createAccessUser (
        first_name: $first_name
        last_name: $last_name
        email: $email
        enabled: $enabled
        warehouse_ids: $warehouse_ids
        groupIds: $groupIds
        profileIds: $profileIds
        external_id: $external_id
      ) {
        id
      }
    }`, state.accessUser)
    .then(({ data }) => {
      commit('setLoading', false);
      ScToast.success('Usuário de acesso criado com sucesso.');
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  updateAccessUser({ commit, state }) {
    commit('setLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!
      $first_name: String!
      $last_name: String!
      $email: String!
      $enabled: Boolean!
      $warehouse_ids: [Int]!
      $groupIds: [Int]!
      $profileIds: [Int]
      $external_id: String
    ) {
      updateAccessUser (
        id: $id
        first_name: $first_name
        last_name: $last_name
        email: $email
        enabled: $enabled
        warehouse_ids: $warehouse_ids
        groupIds: $groupIds
        profileIds: $profileIds
        external_id: $external_id
      ) {
        id
      }
    }`, state.accessUser)
    .then(({ data }) => {
      commit('setLoading', false);
      ScToast.success('Usuário de acesso atualizado com sucesso.');
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  removeAccessUser({ commit, dispatch }, accessUser) {
    commit('setLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!
    ) {
      removeAccessUser (
        id: $id
      ) {
        id
      }
    }`, accessUser)
      .then((res) => {
        commit('setLoading', false);
        ScToast.success('Usuário excluído com sucesso.');
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('setLoading', false);
        return Promise.reject(err);
      });
  },

  unblockAccessUser({ commit }, accessUser) {
    commit('setLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!
    ) {
      unblockAccessUser (
        id: $id
      ) {
        id
      }
    }`, accessUser)
    .then(({ data }) => {
      commit('setLoading', false);
      ScToast.success('Usuário desbloqueado com sucesso.');
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },

  enabledAccessUser({ commit }, accessUser) {
    commit('setLoading', true);
    return GraphQlClient.mutation(`
    mutation (
      $id: Int!
      $enabled: Boolean!
    ) {
      enabledAccessUser (
        id: $id
        enabled: $enabled
      ) {
        id
      }
    }`, accessUser)
    .then(({ data }) => {
      commit('setLoading', false);
      return Promise.resolve(data);
    })
    .catch((err) => {
      commit('setLoading', false);
      return Promise.reject(err);
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-users/store/actions.js